import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ComponentView } from '../../models/component-view.model';
import { AppMainComponent } from '../app-main/app-main.component';

@Component({
    selector: 'app-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrl: './page-not-found.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PageNotFoundComponent extends ComponentView {

    async goHome(): Promise<void> {
        await this.app.navigateToComponent(AppMainComponent, {}); 
    }
}
